import * as HomeCareActionType from './constants';

const initialState = {
  categories: [],
  articlesList: [],
  selectedCategory: null,
  loading: false
};

const HomeCareReducer = (state = initialState, action) => {
  switch (action.type) {
    case HomeCareActionType.GET_ARTICLES_CATEGORIES_ASYNC:
      return {
        ...state,
        loading: true
      };
    case HomeCareActionType.GET_ARTICLES_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.data,
        loading: false
      };
    case HomeCareActionType.GET_ARTICLES_LIST_ASYNC:
      return {
        ...state,
        loading: true
      };
    case HomeCareActionType.GET_ARTICLES_LIST_SUCCESS:
      return {
        ...state,
        articlesList: action.data,
        selectedCategory: action.categoryId,
        loading: false
      };
    default:
      return state;
  }
};

export default HomeCareReducer;



// WEBPACK FOOTER //
// ./src/HomeCare/reducers.js